import { useEffect } from 'react';
import { closeLoadingScreen } from 'areas/layout/utilities/closeLoadingScreen';

export const CloseLoadingScreenOnUnmount = () => {
    useEffect(() => {
        return closeLoadingScreen
    });
    return null;
}
